import {
  View,
  Text,
  TouchableOpacity,
  StyleSheet,
  Platform,
  Image,
} from "react-native";
import React, { useState, useEffect } from "react";

import { useNavigation } from "@react-navigation/native";
import BottomBarIcons from "../../assets/Icons/BottomBarIcons";
import { RootState, useSelector } from "../../redux/store";
import { getUser } from "../../services/ProfileSettings/ProfileSettingService";
import AsyncStorage from '@react-native-async-storage/async-storage';

export default function CustomTabBar({
  state,
  descriptors,
}: // navigation,
  {
    state: any;
    descriptors: any;
    // navigation: any;
  }) {
  const navigation = useNavigation();
  const [userData, setData] = useState("");

  async function getUserData() {
    const response = await getUser();
    const jsonValue = JSON.stringify(response?.data);
    await AsyncStorage.setItem('user', jsonValue);
    const value = await AsyncStorage.getItem('user');
    const final=value != null ? JSON.parse(value) : null;
    setData(final.photos[0]);
  }
  // let profile = useSelector((state: RootState) => state.profile);
  const value = AsyncStorage.getItem('user');
  useEffect(() => {
    const fetchData = async () => {
      try {
        const value = await AsyncStorage.getItem('user');
        if (value == null) {
          await getUserData();
        }
        else
        {
          const final=value != null ? JSON.parse(value) : null;
          setData(final.photos[0]); 
        }

      } catch (error) {
        console.error(error);
      }
    };

    fetchData();
  }, [value]); // T

  return (
    <>
      <View style={[styles.container]}>
        {state.routes.map((route: any, index: any) => {
          const IconComponent =
            route.name === "HomeFeed" ? (
              <BottomBarIcons.HomeIcon active={state.index === index} />
            ) : route.name === "Interests" ? (
              <BottomBarIcons.InterestIcon active={state.index === index}/>
            ) : route.name === "Matches" ? (
              <BottomBarIcons.ChatIcon active={state.index === index}/>
            ) : route.name === "Discover" ? (
              <BottomBarIcons.DiscoverIcon active={state.index === index}/>
            ) : (
              <>
                {userData === "" ? (
                  <BottomBarIcons.ProfileDemo />
                ) : (
                  <View style={{ height: 26, width: 26, borderRadius: 30 }}>
                    <Image
                      style={{ height: 26, width: 26, borderRadius: 30 }}
                      source={{ uri: userData || "" }}
                    />
                  </View>
                )}
              </>
            );
          return (
            <TouchableOpacity
              key={index}
              onPress={() => {
                navigation.navigate(route.name as never);
              }}
              style={{
                flex: 1,
                justifyContent: "center",
                alignItems: "center",
                paddingBottom: Platform.OS === "ios" ? 20 : 0,
                opacity: state.index === index ? 1 : 0.3,
              }}
            >
              {IconComponent}
              {/* <route.icon /> */}
            </TouchableOpacity>
          );
        })}
      </View>
    </>
  );
}

const styles = StyleSheet.create({
  container: {
    backgroundColor: "#000",
    flexDirection: "row",
    height: Platform.OS === "web" ? 65 : Platform.OS === 'android' ? 65 : 80,
  },
});
